window.App = Object.assign(window.App || {}, {
    W: $(window),
    D: $(document),
    H: $('html'),
    B: $('body'),
    ie: false,
    edge: false,
    firefox: false,
    mainpage: false,
    mobileWidth: 767,
    lang: $('html').attr('lang') || 'ru',
});


// Классы страницы
{
    if (App.H.hasClass('mobile')) {
        App.mobile = true;
    } else if (App.H.hasClass('safari') && 'ontouchstart' in window) {
        App.mobile = true;
        App.H.removeClass('osx').addClass('mobile ios');
    } else {
        App.H.addClass('desktop');
    }

    if (App.H.hasClass('ie')) {
        App.ie = true;
    }

    if (App.H.hasClass('edge')) {
        App.edge = true;
    }

    if (App.H.hasClass('firefox')) {
        App.firefox = true;
    }

    if (App.H.hasClass('page-main')) {
        App.mainpage = true;
    }
}

// ключи для карты
const MAP_KEY_PROD = 'f6716e5c-05f2-44ac-b723-2648cb74a7f5';
const MAP_KEY_TEST = 'e79ab9db-e1c4-41a7-96c7-542bdc90129b'; // TODO: вынести тестовый ключ в html
const MAP_KEY = /cpeople.ru/.test(location.hostname) || ['deploy.stada.ru','localhost'].indexOf(location.hostname) > -1 ? MAP_KEY_TEST : MAP_KEY_PROD;

// пути для js библиотек
const DIR = '/js/libs/';
export const LIB_URL = {
    SWIPER:             DIR + 'swiper/swiper-bundle.min.js',
    JQ_SUGGESTIONS:     DIR + 'jquery.suggestions.min.js',
    JQ_FORM:            DIR + 'jquery.form.min.js',
    LAZYSIZES:          DIR + 'lazysizes.min.js',
    JQ_INTLTELINPUT:    DIR + 'intlTelInput/intlTelInput-jquery.min.js',
    JQ_INPUTMASK:       DIR + 'jquery.inputmask.bundle.min.js',
    MUURI:              DIR + 'muuri.min.js',
    PLYR:               DIR + 'plyr/plyr.min.js',
    STICKY:             DIR + 'sticky.js',
    SCROLLMAGIC:        DIR + 'scrollMagic/ScrollMagic.min.js',
    JQ_UI:              DIR + 'jquery-ui/jquery-ui.min.js',
    JQ_TIMEPICKER:      DIR + 'timepicker/jquery.timepicker.min.js',
    PDFOBJECT:          DIR + 'pdfobject.min.js',
    UTEKA:              DIR + 'Uteka.js',
    YAMAP:              `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${MAP_KEY}`,
};
